module.exports = __webpack_public_path__ + "static/media/empty-desktop.cf95b104.png";